import { render, staticRenderFns } from "./AdminDepartmentIndexPageTableRow.vue?vue&type=template&id=5ca006c8&"
import script from "./AdminDepartmentIndexPageTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminDepartmentIndexPageTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports